import { AffiliateRepresentation, AffiliateRepresentationFile, AffiliateRepresentationType } from '@/interfaces/affiliates';
import { CBU } from '@/interfaces/cbu';
import { Note } from '@/interfaces/note';
import { PaginatedResponse } from '@/interfaces/response';
import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function queryRepresentatives(params: any) {
  return request({
    url: 'affiliate-representatives/',
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<AffiliateRepresentation>>;
}

export async function getRepresentative(id: number) {
  return request({
    url: `affiliate-representatives/${id}/`,
    method: 'GET',
  }) as AxiosPromise<AffiliateRepresentation>;
}

export async function updateRepresentative(id: number, data: any) {
  return request({
    url: `affiliate-representatives/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<AffiliateRepresentation>;
}

export async function updateRepresentation(id: number, data: any) {
  return request({
    url: `affiliate-representatives/${id}/update-representation/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<AffiliateRepresentation>;
}

export async function queryRepresentativeChangesHistory(id: number | string) {
  return request({
    url: `affiliate-representatives/${id}/changes-history/`,
    method: 'GET',
  }) as AxiosPromise<AffiliateRepresentation[]>;
}

export async function updateRepresentativeStatus(id: number | string, data: any) {
  return request({
    url: `affiliate-representatives/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<AffiliateRepresentation>;
}

export async function sendRepresentativeNote(id: number | string, data: { content: string }) {
  return request({
    url: `affiliate-representatives/${id}/notes/`,
    method: 'POST',
    data
  }) as AxiosPromise<Note<AffiliateRepresentation>>;
}

export async function getRepresentativeNotes(id: number | string) {
  return request({
    url: `affiliate-representatives/${id}/notes/`,
    method: 'GET'
  }) as AxiosPromise<Note<AffiliateRepresentation>[]>;
}

export async function queryRepresentativesTypes(params: any = {}) {
  return request({
    url: 'affiliate-representatives-types/',
    method: 'GET',
    params
  }) as AxiosPromise<AffiliateRepresentationType[]>;
}

export async function uploadRepresentative(data: any) {
  return request({
    url: 'affiliate-representatives/',
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateRepresentationType[]>;
}

export async function createAffiliateRepresentative(data: any) {
  return request({
    url: 'affiliate-representatives/affiliate-create/',
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateRepresentationType[]>;
}

export async function uploadCBU(data: any) {
  return request({
    url: 'cbu/',
    method: 'POST',
    data
  }) as AxiosPromise<CBU>;
}

export async function updateCBU(id: number, data: any) {
  return request({
    url: `cbu/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<CBU>;
}

export async function uploadFile(data: any) {
  return request({
    url: `affiliate-representatives/upload-file/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  }) as AxiosPromise<AffiliateRepresentationFile>;
}
